<template>
<div class="powerStation-page" v-if="isSmallScreen===false">
<headers :imageSrc="imageSrc"/>
<po-mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<bottom/>
</div>
<div class="powerStation-page" v-else>
<headers :imageSrc="imageSrc"/>
<power-mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<power-foot/>
</div>
</template>
<script>
import headers from '../../components/headers.vue'
import bottom from '@/components/bottom'
import PowerMains from '../../components/powerMains.vue'
import PowerFoot from '../../components/powerFoot.vue'
import PoMains from '../../components/po-Mains.vue'
export default {
  components: { headers, bottom, PowerMains, PowerFoot, PoMains },
  data () {
    return {
      isSmallScreen: false,
      imageSrc: '../assets/image/tlf_lsjt_xnydz.png',
      res1: '碳立方-绿色减碳-新能源电站',
      res2: '实现新能源电站，制氢工厂，加氢站，换电站的资产台账管理，发电量数据在线检测，故障排查,AI无人机巡检，备品备件和供应商管理，帮助电站优化资产运营和库存，降低运营成本，提升运',
      res3: '营效率。',
      res4: '一：某煤基产业园区零碳大脑项目  /  二：某信息港智能制造产业园零碳大脑项目',
      res5: '../assets/2023logoImage/tlf_lsjt_xnydz.png'
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/xnydzbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/xnydzbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>

<style scoped>

</style>
